import { render, staticRenderFns } from "./up-img.vue?vue&type=template&id=9e36896c&scoped=true&"
import script from "./up-img.vue?vue&type=script&lang=js&"
export * from "./up-img.vue?vue&type=script&lang=js&"
import style0 from "./up-img.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./up-img.vue?vue&type=style&index=1&id=9e36896c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e36896c",
  null
  
)

export default component.exports